import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorsArrayService {
  private colors;
  constructor() { }

  ColorsArray(a?:string){
    //switch (a) {
     // case 'AU':
        this.colors = ["#F6603B", "#3B82F6", "#F38132", "#00D47E", "#a1a0cf", "#939598", "#2dcb75", "#26d7ae", "#ff6680", "#ff7300"];
       // break;
   // }
    return this.colors;
  }
}
